import React, { useState, useEffect } from "react";

function Fishes() {

    const [Fishes, setFishes] = useState([]);

    useEffect(() => {
        fetch('https://strapi.restauracjasamiswoi.pl/api/categories?populate=menu_items')
        .then(response => response.json())
        .then(data => {
            const category = data.data.find(item => item.name === 'RYBY');

            if (category) {
                setFishes(category.menu_items);
            };
        });
    }, []);

    return(

        <div className="container-fluid">
            <div className="container pb-5">
            <p className="menu-item-title-font fs-1 fw-bold pt-5">RYBY</p>
            <hr/>
            {Fishes.map((fish) => (
                <div key={fish.id} className="container">
                    <div className="dish-name-container d-flex justify-content-between">
                        <p className="menu-item-title-font fs-5 m-0">{fish.name}</p>
                        <p className="fs-5 no-wrap m-0">{fish.price}zł</p>
                    </div>
                    <p className="ingridients-container fs-6 m-0 fw-lighter">{fish.ingredients}</p>
                    <div className="mb-3 mt-3 divide-line"/>
                </div>
            ))}
        </div>
        </div>
    )
}

export default Fishes;